export default "__VITE_ASSET__fgOt_Ow9__"